import { Badge, Box } from "@chakra-ui/react";

interface SummaryBadgeProps {
    count: number;
    label: string;
    colorScheme: string;
    isActive?: boolean;
    onClick?: () => void;
}

export const SummaryBadge = (props: SummaryBadgeProps) => {
    const { count, label, colorScheme, isActive = false, onClick } = props;
    const isInteractive = !!onClick;

    return (
        <Badge
            as={isInteractive ? "button" : undefined}
            type={isInteractive ? "button" : undefined}
            bg={`${colorScheme}.100`}
            color={`${colorScheme}.800`}
            borderRadius="full"
            px={3}
            py={1}
            display="flex"
            alignItems="center"
            gap={1.5}
            fontWeight="medium"
            textTransform="none"
            cursor={isInteractive ? "pointer" : undefined}
            opacity={isInteractive && !isActive ? 0.5 : 1}
            transition="opacity 0.3s ease, transform 0.3s ease"
            transform={isActive ? "scale(1.05)" : "scale(1)"}
            _hover={isInteractive ? { opacity: 0.85 } : undefined}
            _focusVisible={isInteractive ? { boxShadow: "outline" } : undefined}
            onClick={onClick}
        >
            <Box w="6px" h="6px" borderRadius="full" bg={`${colorScheme}.500`} />
            {count} {label}
        </Badge>
    );
};